import { map } from 'rxjs/operators';
import { mapProperty } from '../helpers/map-property.helper';
import { MappedSingletonResponse } from '../models/mapped-singleton-response.model';
import { SingletonResponse } from '../models/singleton-response.model';

export const mapSingletonProperties = map((response: SingletonResponse): MappedSingletonResponse => ({
  ...response,
  includedMap: mapProperty(response.included),
}));
